import { render, staticRenderFns } from "./DetalleVODForm.vue?vue&type=template&id=49079822&scoped=true&"
import script from "./DetalleVODForm.vue?vue&type=script&lang=ts&"
export * from "./DetalleVODForm.vue?vue&type=script&lang=ts&"
import style0 from "./DetalleVODForm.vue?vue&type=style&index=0&id=49079822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49079822",
  null
  
)

export default component.exports